<template>
<div class="container-share">
    <div v-if="initData">
        <div class="header-share">
            <van-count-down :time="time">
                <template #default="timeData">
                    <span class="block">{{
              timeData.hours > 9 ? timeData.hours : "0" + timeData.hours
            }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{
              timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes
            }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{
              timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds
            }}</span>
                </template>
            </van-count-down>
            <p>
                还差<span class="text-theme">{{ initData.differenceMembers }}</span>人，赶快邀请好友来拼单吧
            </p>
            <div class="button share" @click="share()">邀请好友拼单</div>
            <div class="button back" @click="index">去首页逛逛</div>
        </div>

        <div class="share-num">
            <div class="photo-main" v-for="(item, index) in initData.groupInstDetailResponseList" :key="index">
                <div class="photo-tag" v-if="item.headFlag == 1">拼主</div>
                <div class="photo-main" v-else></div>
                <img src="../../../static/images/product/photo.png" class="border" />
            </div>
            <div class="photo-main" v-for="(item, index1) in differenceNums" :key="index1">
                <img src="../../../static/images/product/photo.png" />
            </div>
        </div>

        <div class="cell-main">
            <div class="cell">
                <p class="cell-title">订单详情</p>
                <div class="flex align-center">
                    <p class="cell-content" @click="goOrderDetail()">
                        {{
                initData.groupProductResponse
                  ? initData.groupProductResponse.mpName
                  : ""
              }}
                    </p>
                    <van-icon name="arrow" />
                </div>
            </div>
            <div class="cell">
                <p class="cell-title">拼团规格</p>
                <div class="flex align-center">
                    <p class="cell-content text-999">好友拼单 人满发货 人不满退款</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import wx from "weixin-js-sdk";
import {
    getCurrentJoinedGroupInfo
} from "@/api/api";
import notData from "@/components/notData";
export default {
    components: {},
    data() {
        return {
            time: 30 * 60 * 1000,
            groupInstCode: this.$route.query.groupInstCode, //拼团实例编码
            initData: {},
            differenceNums: [],
        };
    },
    mounted: function (options) {
        // this.init();
    },
    created() {
        this.init();
    },
    methods: {
        purchase: function () {},
        async init() {
            let sendData = {
                groupInstCode: this.groupInstCode,
            };
            const res = await getCurrentJoinedGroupInfo(sendData);
            if (res.code == "0000") {
                // debugger
                this.initData = res.data;
                // 计算倒计时
                if (this.initData.expireTime) {
                    this.time = this.initData.expireTime - new Date().getTime();
                }
                if (this.initData.differenceMembers > 0) {
                    this.differenceNums = new Array(this.initData.differenceMembers);
                }
            }
        },
        // 跳转订单详情
        goOrderDetail() {
            this.$router.push({
                path: "/OrderDetail",
                query: {
                    orderNo: this.initData.orderInfo.orderNo
                },
            });
        },
        // 邀请好友
        share() {},
        index() {
            wx.miniProgram.switchTab({
                url: "/pages/index/index",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.container-share {}

.header-share {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 10px;

    p {
        font-size: 26px;
        font-weight: 600;
        color: #333333;
        margin: 40px;
    }
}

.colon {
    display: inline-block;
    margin: 0 4px;
    color: $theme-color-main;
}

.block {
    display: inline-block;
    color: #fff;
    font-size: 26px;
    text-align: center;
    width: 40px;
    height: 40px;
    background: $theme-color-main;
    border-radius: 5px;
}

.button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 580px;
    height: 88px;
    border-radius: 43px;
    margin-bottom: 20px;
}

.share {
    font-size: 36px;
    color: #ffffff;
    background: $theme-color-main;
}

.back {
    border: 2px solid #ececec;
    font-size: 36px;
    color: #3464ad;
}

.share-num {
    padding: 32px;
    background: #ffffff;
    margin: 20px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
}

.photo-main {
    position: relative;
    margin-left: 20px;
    margin-right: 20px;

    img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }

    .photo-tag {
        width: 65px;
        height: 36px;
        background: #e93b45;
        border: 2px solid #ffffff;
        border-radius: 18px;
        color: #ffffff;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -3px;
        left: -5px;
    }
}

.border {
    border: solid 1px $theme-color-main;
}

.cell-main {
    background: #ffffff;
    border-radius: 20px;
    margin: 0 20px;
    font-size: 26px;
    padding: 20px 30px;

    .cell {
        display: flex;
        justify-content: space-between;
        padding: 15px 0;
    }
}
</style>
